import { Box, Button, Group, Modal } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ContractInformationProps {
  opened: boolean;
  onClose: () => void;
  fileUrl: string;
  onDowload?: any;
}
const ContractInformation = ({
  fileUrl,
  onClose,
  opened,
  onDowload,
}: ContractInformationProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t<string>("CONTRACT_INFORMATION")}
      size="lg"
      centered
      styles={{
        body: { padding: 0 },
      }}
    >
      <div style={{ height: "80vh" }}>
        <iframe
          src={`${fileUrl}#toolbar=0`}
          title={t<string>("CONTRACT_INFORMATION")}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </div>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          zIndex: 2,
          padding: "16px",
          backgroundColor: "#fff",
          boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.05)",
          width: "100%",
        }}
      >
        <Group position="right" w="100%">
          <Button
            sx={{
              color: "#FDFDFD",
              backgroundColor: "#2A81D0",
              "&:hover": { backgroundColor: "#2A81D0" },
              "&:active": { backgroundColor: "#2A81D0" },
              "&:focus": { outline: "none", boxShadow: "none" },
              padding: "10px 24px",
              borderRadius: "8px",
            }}
            onClick={() => {
              onDowload();
              //   onClose();
            }}
          >
            {t("DOWNLOAD")}
          </Button>
        </Group>
      </Box>
    </Modal>
  );
};

export default ContractInformation;
